import { createAction } from '@mews/framework';
import { Customer } from '@mews-commander/data-access';
import prefix from '../prefix';

export const RESOURCE_USE_SELECTED = prefix('RESOURCE_USE_SELECTED');
export const RESOURCE_USE_DESELECTED = prefix('RESOURCE_USE_DESELECTED');
export const RESOURCE_USE_UPDATED = prefix('RESOURCE_USE_UPDATED');
export const MODE_CHANGED = prefix('MODE_CHANGED');

export const deselectResourceUse = (scope: string) => createAction(RESOURCE_USE_DESELECTED, null, { scope });

export const selectResourceUse = (
    resourceUse: {
        id: string;
        groupId: string;
        isReservation: boolean;
        customer: Customer | undefined;
        customerId: string;
        assignedResourceLocked: boolean;
    },
    scope: string
) => createAction(RESOURCE_USE_SELECTED, resourceUse, { scope });

export const changeMode = (mode: $TSFixMe, scope: string) => createAction(MODE_CHANGED, mode, { scope });
